<template>
    <section class="section">
        <div class="spring">
            <div class="container">
                <div v-if="$route.name === 'main' || ($root.serviceActive && $root.serviceActive.url !== 'internet')">
                    <h2 class="heading heading--3 heading--center">Întrebări frecvente</h2>
                    <ul class="services-list">
                        <!-- <li v-for="question in $root.questionsVisible"> -->
                        <li v-for="question in $root.questions">
                            <router-link
                                :to="{
                                    name: 'faq',
                                    params: { questionName: question.name, question: question },
                                }"
                            >
                                <span>{{ question.title }}</span>
                                <span class="text-right">
                                    <i class="icon icon-chevron-right">&nbsp;</i>
                                </span>
                            </router-link>
                        </li>
                        <li>
                            <a target="_blank" rel="noopener noreferrer" href="https://api-cms.vodafone.ro/dA/eac6436284/Alte%20servicii%20disponibile%20in%20roaming%20SEE.pdf?language_id=1">
                                <span>Alte servicii disponibile în roaming SEE</span>
                                <span class="text-right">
                                    <i class="icon icon-chevron-right">&nbsp;</i>
                                </span>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="asistenta-directa">
            <MyVodafoneDownload></MyVodafoneDownload>

            <div class="section-feedback section--white section--card" data-html2canvas-ignore="true">
                <feedback view="card"></feedback>
            </div>
        </div>
    </section>
</template>

<script>
import MyVodafoneDownload from './MyVodafoneDownload';

export default {
    components: {
        MyVodafoneDownload,
    },

    data() {
        return {};
    },
    watch: {},
    methods: {},
    mounted() {},
};
</script>
